import React, { useEffect } from "react";
import { useServerConnection } from "../hooks/ServerConnection";
import { useGitlabAccessToken } from "../hooks/GitlabAccessToken";


const ConfirmVMDeletion = ({ machineId, onClose }: { machineId: string, onClose: () => void }) => {
    const [accessToken] = useGitlabAccessToken()
    const serverConnection = useServerConnection()

    useEffect(() => {
        const keyboardListener = (e: KeyboardEvent) => {
            if(e.code === "Escape") {
                onClose()
            }
        }
        window.addEventListener('keydown', keyboardListener)

        return () => {
            window.removeEventListener('keydown', keyboardListener)
        }
    }, [])

    return (
        <div
            className='fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center'
            style={{
                zIndex: 100,
            }}
            onClick={() => onClose()}
        >
            <div
                className='bg-white rounded-md p-8 flex flex-col'
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className='text-2xl font-bold mb-4'>Confirm Delete</h2>
                <p className='mb-4'>Are you sure you want to delete this virtual machine?</p>
                <div className='flex justify-between'>
                    <button className='bg-error text-white p-2 rounded-md' onClick={(e) => {
                        serverConnection.removeVM(accessToken, machineId);
                        onClose()
                    }}>Yes</button>
                    <button className='bg-secondary text-white p-2 rounded-md' onClick={(e) => {
                        onClose()
                    }}>No</button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmVMDeletion
